import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _TASK_ACTIVITY_COMPON;

import { TaskActivityType } from 'core/modules/tasks/task.interface';
import { TaskActivityAssigneeChanged } from './AssigneeChanged';
import { TaskActivityCreated } from './Created';
import { TaskActivityDeleted } from './Deleted';
import { TaskActivityStateChanged } from './StateChanged';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var TASK_ACTIVITY_COMPONENT = (_TASK_ACTIVITY_COMPON = {}, _defineProperty(_TASK_ACTIVITY_COMPON, TaskActivityType.Created, TaskActivityCreated), _defineProperty(_TASK_ACTIVITY_COMPON, TaskActivityType.StateChanged, TaskActivityStateChanged), _defineProperty(_TASK_ACTIVITY_COMPON, TaskActivityType.AssigneeChanged, TaskActivityAssigneeChanged), _defineProperty(_TASK_ACTIVITY_COMPON, TaskActivityType.Deleted, TaskActivityDeleted), _TASK_ACTIVITY_COMPON);
export var TaskActivityItem = function TaskActivityItem(_ref) {
  var task = _ref.task,
      activity = _ref.activity;
  var Component = TASK_ACTIVITY_COMPONENT[activity.type];

  if (!Component) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx(Component, {
    task: task,
    activity: activity
  });
};